module.exports = require('./MortgageDiscountCompanyAnnualReportView');